exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CtnDetalization_title_3UbD {\n  margin-bottom: 20px;\n\n  display: inline-block;\n}\n\n.CtnDetalization_expensesAmount_1Ibj {\n  margin-right: 30px;\n\n  display: inline-block;\n}\n\n.CtnDetalization_tooManyTransactionsMessage_3bR- {\n  margin-bottom: 20px;\n\n  font-size: 17px;\n  text-align: center;\n}\n\n.CtnDetalization_tooManyTransactionsTitle_3bq3 {\n  margin: 0 120px 20px 120px;\n\n  display: inline-block;\n}\n\n.CtnDetalization_preloader_bT5c {\n  position: static;\n\n  -webkit-transform: none;\n\n          transform: none;\n}\n", ""]);

// exports
exports.locals = {
	"title": "CtnDetalization_title_3UbD",
	"expensesAmount": "CtnDetalization_expensesAmount_1Ibj",
	"tooManyTransactionsMessage": "CtnDetalization_tooManyTransactionsMessage_3bR-",
	"tooManyTransactionsTitle": "CtnDetalization_tooManyTransactionsTitle_3bq3",
	"preloader": "CtnDetalization_preloader_bT5c"
};